import React from 'react';
import ReactDOM from 'react-dom/client';

// --- THE CRITICAL FIX ---
// The global CSS file MUST be imported here, at the very top level,
// before any of your components are imported via App.js.
import './index.css'; 

import App from './App';
import HandheldApp from './handheld/HandheldApp';
import axios from 'axios';
import { bootstrapOta } from './services/ota/otaBootstrap';

// --- AXIOS INTERCEPTOR SETUP ---
// This logic is correct and should remain.
axios.interceptors.request.use(config => {
  const activeStoreId = localStorage.getItem('activeStoreId');
  if (activeStoreId) {
    if (config.method === 'post' || config.method === 'put' || config.method === 'delete') {
      // Only modify config.data if it's not FormData
      if (!(config.data instanceof FormData)) {
        const hasExplicitStoreId = Object.prototype.hasOwnProperty.call(config.data || {}, 'storeId');
        if (!hasExplicitStoreId) {
          config.data = { ...config.data, storeId: activeStoreId };
        }
      }
    } else if (config.method === 'get') {
      const hasExplicitStoreId = Object.prototype.hasOwnProperty.call(config.params || {}, 'storeId');
      const requestScope = String(config.params?.scope || '').toLowerCase();
      if (!hasExplicitStoreId && requestScope !== 'all') {
        config.params = { ...config.params, storeId: activeStoreId };
      }
    }
  }
  return config;
}, error => {
  return Promise.reject(error);
});
// --- END OF INTERCEPTOR SETUP ---

const EntryApp = process.env.REACT_APP_APP_TARGET === 'handheld' ? HandheldApp : App;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <EntryApp />
  </React.StrictMode>
);

// Once the app shell has rendered, signal the running web bundle booted OK
// (OTA rollback safety) and begin idle-gated update checks. No-op on web/desktop.
setTimeout(() => bootstrapOta(), 0);
